
import React, { Component } from 'react'
import Header from './components/header'
import Footer from './components/footer'

import PageTilte from './components/pageTilte';
import Sidebar from './components/produce/sidebar';
import axios from 'axios';
import { constantApp } from '../../config/constant';
import dompurify from 'dompurify';
import { Link } from 'react-router-dom';

class ProduceDetail extends Component {

    constructor(props) {



        super(props);
        const { match: { params } } = this.props;

        this.state = {
            idProduce: params.id,// this.props.location.state.id, //this.props.match.params.id
            ProduceName: '',
            Brief: '',
            Content: '',
            isLoading: true,
            // isNetworkError: false

        };
    }


    componentDidUpdate(prevProps) {
        if (prevProps.location.key !== this.props.location.key) {
            //  window.scrollTo(0, 0)
            window.location.reload();

        }
    }

    componentDidMount = async () => {
        // const { match: { params } } = this.props;

        // console.log(params.id)
        // console.log(this.props.params.id)
        window.scrollTo(0, 0)
        let url = `${constantApp.SERVERIP}:${constantApp.PORT_APPACHE}/PHP/Produce/Select_Produce_One.php`;

        let param = {
            idProduce: this.state.idProduce,
        }

        let data = await axios.post(url, param)
            .then(function (response) {

                return response.data;
            })
            .catch(function (error) {
                // this.setState({ isNetworkError: true })

            });



        if (data !== undefined && data.length > 0) {
            let n = JSON.parse(JSON.stringify(data[0]));
            let Content = n["Content"];
            let ProduceName = n["ProduceName"];
            let Brief = n["Brief"];
            this.setState({
                ProduceName,
                Brief,
                Content,
                isLoading: false,

            })
        }

    }



    render() {
        const sanitizer = dompurify.sanitize;
        return (
            <div >
                <Header />


                <PageTilte title={'توضیحات محصول'} />


                <section className="service-singel-section section-padding">
                    <div className="container">
                        <div className="row">
                            <div className="col col-md-8 col-md-push-4">
                                <div className="service-single-content">
                                    {/* <div>

                                        <img src={process.env.PUBLIC_URL + "/assets/images/produce-single-info.jpg"} alt='' role='presentation' />
                                    </div> */}
                                    <div className="title">
                                        <h3>{this.state.ProduceName}</h3>
                                        <div className="download">
                                            <a href={`${constantApp.SERVERIP}/APAFAN/Documents/${this.state.idProduce}.pdf`} download ><i className="fa fa-file-pdf-o"></i> دانلود پی دی اف</a>
                                        </div>
                                    </div>


                                    {this.state.isLoading ?
                                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyItems: 'center', justifyContent: 'center' }}>
                                            <br />
                                            <br />
                                            <br />
                                            <i className="fa fa-circle-o-notch fa-spin" style={{ fontSize: 24 }}></i>
                                            <br />
                                            <p >در حال بارگزاری اطلاعات</p>
                                        </div>

                                        :

                                        <div className="details">
                                            <p dangerouslySetInnerHTML={{ __html: sanitizer(this.state.Content) }} />
                                            {/* <p>{this.state.Content}</p> */}
                                            <br />
                                            <Link to={{ pathname: '/contact', state: { from: 'root' } }} className="theme-btn">تماس با ما</Link>
                                        </div>
                                    }



                                </div>
                            </div>

                            <Sidebar idProduce={this.state.idProduce} />
                        </div>
                    </div>
                </section>


                <Footer />
            </div >
        );
    }
};



export default ProduceDetail; 